import { handleActions, combineActions } from 'redux-actions';
import { Map } from 'immutable';

import actions from '../actions';

//REDUCERS
const { filters: filtersActions } = actions.customer;

/** Filters */

export default handleActions(
  {
    [combineActions(
      filtersActions.get.toString(),
      filtersActions.set.toString(),
      filtersActions.apply.toString(),
      filtersActions.clear.toString(),
      filtersActions.update.toString()
    )]: (hotel, { payload }) => {
      return payload;
    }
  },
  Map({
    hotels: null,
    options: null
  })
);
